import { z } from 'zod';

/**
 * https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#partner
 * The Europace 2 Partner-ID has 5-characters and has the format ABC12.
 *
 * The property kundenbetreuer.partnerId is mandatory.
 *
 * {
 *  "partnerId": String
 * }
 */

export const schemaEuropacePartnerId = z
    .string()
    .regex(/^[A-Z]{3}\d{2}$/)
    .min(1);

export type SchemaEuropacePartnerId = z.infer<typeof schemaEuropacePartnerId>;

export const schemaEuropacePartner = z.object({
    partnerId: schemaEuropacePartnerId,
});

export type SchemaEuropacePartner = z.infer<typeof schemaEuropacePartner>;
